import { cn } from "./utils";

export default function Paper({ children, className = "", style, ...props }) {
  return (
    <div
      style={{ ...style }}
      className={cn(
        "flex flex-col items-center justify-between grow rounded-[8px] bg-[#fff] shadow-[0_1px_6.5px_0_#224b9923] p-[20px]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
